// extracted by mini-css-extract-plugin
export default {"emptyContainer":"EmptyGrid_emptyContainer__a2kLP","description":"EmptyGrid_description__6Q2ll","title":"EmptyGrid_title__4fALx"};